import styled from 'styled-components';
import { Button } from 'react-bootstrap';

const ColButton = styled(Button)`
  border: 1px solid;
  border-color: rgba(0, 0, 0, 0.125) !important;
  background-color: ${props => (props.selected ? '#007bff' : '#fff')}!important;
  color: #212529 !important;
  flex: 0 0 25%;
  max-width: 25%;
`;

export default {
  ColButton
};
